import { render, staticRenderFns } from "./ImproveDetails.vue?vue&type=template&id=31949b28"
import script from "./ImproveDetails.vue?vue&type=script&lang=js"
export * from "./ImproveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports